import React from 'react';

import WrappedBase from './WrappedBase';
import QuickShopPdp from '../containers/QuickShopPdp';

export default class QuickShopPdpWrapped extends React.Component {
  render() {
    return (
      <WrappedBase>
        <QuickShopPdp {...this.props} />
      </WrappedBase>
    );
  }
}
